import { storeToRefs } from 'pinia';
import { computed } from 'vue';
import { i18n } from '@/libraries/i18n';
import { useFeatureToggleStore } from '@/stores/featureToggleStore';

export const getTranslationBySite = (key: string) => {
    const { isEuroSite } = storeToRefs(useFeatureToggleStore());
    const style = isEuroSite.value ? 'euro' : 'asia';
    return i18n.t(`${key}.${style}`).toString();
};

export const getMaxPayoutText = computed(() => {
    const { isEuroSite } = storeToRefs(useFeatureToggleStore());
    const key = isEuroSite.value ? 'payout_EURO' : 'maxPayout';
    return i18n.t(key).toString();
});
